export default {
  // Dashboard
  GET_OVERVIEW_START: 'GET_OVERVIEW_START',
  GET_OVERVIEW_SUCCESS: 'GET_OVERVIEW_SUCCESS',
  GET_OVERVIEW_FAILURE: 'GET_OVERVIEW_FAILURE',

  GET_ERROR_TREND_START: 'GET_ERROR_TREND_START',
  GET_ERROR_TREND_SUCCESS: 'GET_ERROR_TREND_SUCCESS',
  GET_ERROR_TREND_FAILURE: 'GET_ERROR_TREND_FAILURE',

  GET_ERRORS_BY_TYPE_START: 'GET_ERRORS_BY_TYPE_START',
  GET_ERRORS_BY_TYPE_SUCCESS: 'GET_ERRORS_BY_TYPE_SUCCESS',
  GET_ERRORS_BY_TYPE_FAILURE: 'GET_ERRORS_BY_TYPE_FAILURE',

  GET_ERRORS_BY_BROWSER_START: 'GET_ERRORS_BY_BROWSER_START',
  GET_ERRORS_BY_BROWSER_SUCCESS: 'GET_ERRORS_BY_BROWSER_SUCCESS',
  GET_ERRORS_BY_BROWSER_FAILURE: 'GET_ERRORS_BY_BROWSER_FAILURE',

  GET_ERRORS_BY_PAGE_START: 'GET_ERRORS_BY_PAGE_START',
  GET_ERRORS_BY_PAGE_SUCCESS: 'GET_ERRORS_BY_PAGE_SUCCESS',
  GET_ERRORS_BY_PAGE_FAILURE: 'GET_ERRORS_BY_PAGE_FAILURE',

  GET_API_PERFORMANCE_START: 'GET_API_PERFORMANCE_START',
  GET_API_PERFORMANCE_SUCCESS: 'GET_API_PERFORMANCE_SUCCESS',
  GET_API_PERFORMANCE_FAILURE: 'GET_API_PERFORMANCE_FAILURE',

  // Sessions
  GET_SESSIONS_START: 'GET_SESSIONS_START',
  GET_SESSIONS_SUCCESS: 'GET_SESSIONS_SUCCESS',
  GET_SESSIONS_FAILURE: 'GET_SESSIONS_FAILURE',

  GET_SESSION_DETAIL_START: 'GET_SESSION_DETAIL_START',
  GET_SESSION_DETAIL_SUCCESS: 'GET_SESSION_DETAIL_SUCCESS',
  GET_SESSION_DETAIL_FAILURE: 'GET_SESSION_DETAIL_FAILURE',

  GET_SESSION_EVENTS_START: 'GET_SESSION_EVENTS_START',
  GET_SESSION_EVENTS_SUCCESS: 'GET_SESSION_EVENTS_SUCCESS',
  GET_SESSION_EVENTS_FAILURE: 'GET_SESSION_EVENTS_FAILURE',

  // Heatmaps
  GET_HEATMAP_PAGES_START: 'GET_HEATMAP_PAGES_START',
  GET_HEATMAP_PAGES_SUCCESS: 'GET_HEATMAP_PAGES_SUCCESS',
  GET_HEATMAP_PAGES_FAILURE: 'GET_HEATMAP_PAGES_FAILURE',

  GET_HEATMAP_CLICKS_START: 'GET_HEATMAP_CLICKS_START',
  GET_HEATMAP_CLICKS_SUCCESS: 'GET_HEATMAP_CLICKS_SUCCESS',
  GET_HEATMAP_CLICKS_FAILURE: 'GET_HEATMAP_CLICKS_FAILURE',

  // Frontend Errors
  GET_FRONTEND_ERRORS_START: 'GET_FRONTEND_ERRORS_START',
  GET_FRONTEND_ERRORS_SUCCESS: 'GET_FRONTEND_ERRORS_SUCCESS',
  GET_FRONTEND_ERRORS_FAILURE: 'GET_FRONTEND_ERRORS_FAILURE',

  GET_FRONTEND_ERROR_DETAIL_START: 'GET_FRONTEND_ERROR_DETAIL_START',
  GET_FRONTEND_ERROR_DETAIL_SUCCESS: 'GET_FRONTEND_ERROR_DETAIL_SUCCESS',
  GET_FRONTEND_ERROR_DETAIL_FAILURE: 'GET_FRONTEND_ERROR_DETAIL_FAILURE',

  RESOLVE_FRONTEND_ERRORS_START: 'RESOLVE_FRONTEND_ERRORS_START',
  RESOLVE_FRONTEND_ERRORS_SUCCESS: 'RESOLVE_FRONTEND_ERRORS_SUCCESS',
  RESOLVE_FRONTEND_ERRORS_FAILURE: 'RESOLVE_FRONTEND_ERRORS_FAILURE',

  // Alerts
  GET_ALERT_RULES_START: 'GET_ALERT_RULES_START',
  GET_ALERT_RULES_SUCCESS: 'GET_ALERT_RULES_SUCCESS',
  GET_ALERT_RULES_FAILURE: 'GET_ALERT_RULES_FAILURE',

  GET_ALERT_HISTORY_START: 'GET_ALERT_HISTORY_START',
  GET_ALERT_HISTORY_SUCCESS: 'GET_ALERT_HISTORY_SUCCESS',
  GET_ALERT_HISTORY_FAILURE: 'GET_ALERT_HISTORY_FAILURE',

  CREATE_ALERT_RULE_START: 'CREATE_ALERT_RULE_START',
  CREATE_ALERT_RULE_SUCCESS: 'CREATE_ALERT_RULE_SUCCESS',
  CREATE_ALERT_RULE_FAILURE: 'CREATE_ALERT_RULE_FAILURE',

  UPDATE_ALERT_RULE_START: 'UPDATE_ALERT_RULE_START',
  UPDATE_ALERT_RULE_SUCCESS: 'UPDATE_ALERT_RULE_SUCCESS',
  UPDATE_ALERT_RULE_FAILURE: 'UPDATE_ALERT_RULE_FAILURE',

  DELETE_ALERT_RULE_START: 'DELETE_ALERT_RULE_START',
  DELETE_ALERT_RULE_SUCCESS: 'DELETE_ALERT_RULE_SUCCESS',
  DELETE_ALERT_RULE_FAILURE: 'DELETE_ALERT_RULE_FAILURE',

  // Clear
  CLEAR_SESSION_DETAIL: 'CLEAR_SESSION_DETAIL',
  CLEAR_FRONTEND_ERROR_DETAIL: 'CLEAR_FRONTEND_ERROR_DETAIL',
};
